<template>
  <div>
    <vs-col vs-lg="12" vs-xs="12" v-if="images.length <= 0">
      <div class="upload-btn-wrapper vs-input-primary">
        <label class="vs-input--label">{{label}}</label>
        <div class="btn">
          <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload
          <span v-if="multiple">Files</span>
          <span v-if="!multiple">a File</span>
        </div>
        <input type="file" ref="fileInput" @change="previewFiles" :multiple="multiple" />
      </div>
    </vs-col>
    <vs-col
      :vs-lg="imgSize"
      :vs-xs="imgSize"
      class="text-center bdr"
      v-for="(item, index) in images"
      :key="index"
    >
      <vs-button
        color="danger"
        type="flat"
        icon="clear"
        class="closeBtn"
        @click="deleteImage(item, index)"
      >Delete</vs-button>
      <img
        :src="baseUrl+item"
        class="imgUp"
        height="150px"
        width="150px"/>        
    </vs-col>
  </div>
</template>

<script>
import rest from "../../../rest.js";
import { API } from "../../../common/constants.js";
export default {
  name: "Uploader",
  props: {
    label: {
      type: String,
      default: "Image Upload"
    },
    profile: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    imgSize: {
      type: String,
      default: "9"
    },
    files: {
      type: Array,
      default() {
        return [];
      }
    },
    file: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data: () => ({
    images: [],
    extension: "",
    type: "",
    baseUrl: API.API_BASE.substring(0, API.API_BASE.lastIndexOf('/')) + '/'
  }),
  methods: {
    previewFiles(event) {
      let formdata = new FormData();
      let api = API.UPLOAD_MULTIPLE_IMAGE;
      let key = "url";
      if (this.$props.multiple) {
        for (let i = 0; i < event.target.files.length; i++) {
          formdata.append("images", event.target.files[i]);
        }
      } else {
        formdata.append("image", event.target.files[0]);
        api = this.profile? API.UPLOAD_PROFILE_IMAGE : API.UPLOAD_SINGLE_IMAGE;
        key = "url";
      }
      this.$vs.notify({
        text: "File Uploading",
        color: "warning",
        position: "top-right"
      });
      this.$vs.loading();
      rest
        .post(api, formdata, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right"
            });
          } else {
            const data = response.data.data[key];
            this.$data.images = [];
            if (!this.$props.multiple) {
              this.$data.images.push(data);
            } else {
              this.$data.images = data;
            }

            this.$vs.loading.close();
            this.$vs.notify({
              text: "File Uploaded",
              color: "success",
              position: "top-right"
            });
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch((err) => {
            this.$vs.notify({
              title: "Uploading Error",
              text: err.message,
              color: "danger",
              position: "top-right"
            });
        });
    },
    deleteImage(i, index) {
      rest
        .delete(API.DELETE_IMAGE+'/'+i.substring(i.lastIndexOf('/')+1) )
        .then(r => {
          if (r.status === 200) {
            this.$vs.notify({
              text: "File Deleted",
              color: "success",
              position: "top-right"
            });
            this.$data.images.splice(index, 1);
            let data = this.$data.images;
            if (!this.$props.multiple) {
              data = data.length > 0 ? data[0] : "";
            }
            this.$emit("input", data);
          }
        })
        .catch(err=>{
          this.$vs.notify({
              text: err.response.data.message,
              color: "danger",
              position: "top-right"
            });})
    }
  },
  watch: {
    /* eslint-disable */
    file: function(newVal, oldVal) {
      // watch it
      this.$data.images = [];
      if (newVal != "") {
        this.$data.images.push(newVal);
      }
    },
    /* eslint-disable */
    files: function(newVal, oldVal) {
      // watch it
      this.$data.images = [];
      if (newVal != "") {
        this.$data.images = newVal;
      }
    }
  },
  created() {
    this.$events.on("reset", () => {
      this.$data.images = [];
    });
  }
};
</script>

<style scoped>
.bdr {
  border: 1px solid #f7f7f7;
  padding: 5px;
}
.closeBtn {
  float: right;
  right: 0px;
  top: 0px;
}
.imgUp {
  margin-bottom: 20px;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
